import { render, staticRenderFns } from "./OpenDinnerDate.vue?vue&type=template&id=39561fbe&scoped=true&"
import script from "./OpenDinnerDate.vue?vue&type=script&lang=js&"
export * from "./OpenDinnerDate.vue?vue&type=script&lang=js&"
import style0 from "./OpenDinnerDate.vue?vue&type=style&index=0&id=39561fbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39561fbe",
  null
  
)

export default component.exports